webpackJsonp([4],{

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(150),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)();
// imports


// module
exports.push([module.i, "\n/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}em{font-style:normal}*{-webkit-tap-highlight-color:transparent}*,:after,:before{box-sizing:border-box}img{display:block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}html{font-size:10px;height:100%}@media only screen and (max-width:310px) and (min-width:300px){html{font-size:9px}}@media only screen and (max-width:320px) and (min-width:310px){html{font-size:9px}}@media only screen and (max-width:360px) and (min-width:320px){html{font-size:9px}.filter-menu-list ul li i{margin-top:-.1rem}.filter-menu-list ul li em{margin-top:-.4rem}}@media only screen and (max-width:360px) and (min-width:350px){html{font-size:10px}}@media only screen and (max-width:480px) and (min-width:360px){html{font-size:10px}.filter-menu-list ul li i{margin-top:-.1rem}.filter-menu-list ul li em{margin-top:0}}@media only screen and (max-width:480px) and (min-width:470px){html{font-size:13.33333px}}@media only screen and (max-width:560px) and (min-width:480px){html{font-size:13.33333px}}@media only screen and (max-width:570px) and (min-width:560px){html{font-size:15.83333px}}@media only screen and (max-width:640px) and (min-width:570px){html{font-size:15.83333px}}@media only screen and (max-width:640px) and (min-width:630px){html{font-size:17.77778px}}@media only screen and (max-width:710px) and (min-width:640px){html{font-size:17.77778px}}body{font-family:Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\\\\5FAE\\8F6F\\96C5\\9ED1,Arial,sans-serif;font-size:.86rem;line-height:1.5;color:#333;background-color:#e7ecec;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;min-height:100%}article,aside,blockquote,body,button,dd,details,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,hr,input,legend,li,menu,nav,ol,p,section,td,textarea,th,ul{margin:0;padding:0}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}ol,ul{list-style:none}input::-ms-clear,input::-ms-reveal{display:none}:focus,a{outline:none}a{color:#3eb1fa;background:transparent;text-decoration:none;cursor:pointer;transition:color .2s ease}a:hover{color:#57bbfb}a:active{color:#25a7f9}a:active,a:hover{outline:0;text-decoration:none}a[disabled]{color:#ccc;cursor:not-allowed;pointer-events:none}code,kbd,pre,samp{font-family:Consolas,Menlo,Courier,monospace}.f-left{float:left}.f-right{float:right}.collapse{border:1px solid #e3e8ee}.collapse.close{border-bottom:0}.collapse.close .con{height:0;padding:0}.collapse .title{background:#f3f4f5;overflow:hidden;font-size:1.36rem;height:3.2rem;border-bottom:1px solid #e3e8ee}.collapse .title span{float:left;position:relative}.collapse .title span.rotate-arrow{position:relative}.collapse .title .icon-arrow{font-size:1rem;position:absolute;margin-left:.2rem;transform:rotate(90deg);-ms-transform:rotate(90deg);-moz-transform:rotate(90deg);-webkit-transform:rotate(90deg);-o-transform:rotate(90deg)}.collapse.close .title .icon-arrow{transform:rotate(0);-ms-transform:rotate(0);-moz-transform:rotate(0);-webkit-transform:rotate(0);-o-transform:rotate(0)}.collapse .con{padding:1.8rem 2rem;overflow:hidden}.form-group{margin-bottom:1.2rem;max-width:60rem;display:-ms-flexbox;display:flex;display:-webkit-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:flex-start}.form-group:last-child{margin-bottom:0}.form-group .group-l{float:left;margin-right:1.2rem;font-size:1.36rem;min-width:6rem;color:#464c5b;text-align:right;display:-ms-flexbox;display:flex;display:-webkit-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end}.form-group .group-r{-ms-flex:1;flex:1}.color-input{background:none;border:0}.input-date-group{display:-moz-box!important;display:-webkit-box!important;display:box!important;display:-moz-flex!important;display:-ms-flex!important;display:-ms-flexbox!important;display:flex!important}.input-date-group .el-date-editor.el-input,.input-date-group .el-input{width:86%!important;box-flex:1;-ms-flex:1!important;flex:1!important;-webkit-flex:1!important}.input-date-group a{font-size:.82rem;margin-left:.4rem;margin-top:.4rem}.more-link{font-size:1.3rem;margin-left:.8rem;padding-left:.8rem;border-left:1px solid #e3e8ee;color:#464c5b}.more-link i{font-size:1.2rem}.more-link:hover{color:#464c5b}.ec-remark{margin:.4rem 0;line-height:1.4;font-size:1.2rem;color:#ff495e}.seamless-scroll{overflow:hidden;position:absolute;left:0}.seamless-scroll-wrapper{float:left;display:inline-block;white-space:nowrap}.mask{position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,.7);z-index:122}.ec-tabs.el-tabs--border-card>.el-tabs__header{background:#f3f4f5;border:none;height:3.6rem!important}.el-tabs__nav-wrap{width:100%!important}.el-tabs__nav{height:3.6rem;width:100%;display:-moz-box!important;display:-webkit-box!important;display:box!important;display:-moz-flex!important;display:-ms-flex!important;display:-ms-flexbox!important;display:flex!important}.el-tabs__item.is-active{color:#333!important;background:#fff!important}.el-tabs--border-card>.el-tabs__header>.el-tabs__item.is-active:first-child,.el-tabs--border-card>.el-tabs__header>.el-tabs__item.is-active:last-child{border-left-color:none;border-right-color:none}.el-tabs__item{height:3.6rem!important;line-height:3.6rem!important;text-align:center;color:#666;border:0!important;margin-right:0!important;margin-left:0!important;box-flex:1;-ms-flex:1!important;flex:1!important;-webkit-flex:1!important}.pages .el-tabs--border-card>.el-tabs__content{top:3.6rem;overflow-x:hidden;bottom:0;width:100%;position:absolute}.pages .el-tabs--border-card>.el-tabs__content .el-tab-pane{position:absolute;top:5.4rem;left:0;right:0;bottom:0;padding:15px;overflow-y:scroll}.pages .el-tabs--border-card>.el-tabs__content .el-tab-pane.system{top:.8rem}.el-checkbox__inner:after{width:4px!important;height:7px!important;left:4px!important}.el-radio+.el-radio{margin-left:12px!important}.el-checkbox__inner,.el-radio__inner{width:16px!important;height:16px!important}.el-dropdown-menu{border-radius:8px;border:0!important;box-shadow:0 0 8px hsla(0,0%,42%,.3)!important;padding:.7rem 0!important}.el-dropdown-menu__item{font-size:1.3rem;padding:0 16px!important;line-height:30px!important}.el-dropdown-menu__item:hover{color:#3eb1fa!important;background:none!important}.el-input__inner{font-size:13px!important;padding:2px 8px!important;border:1px solid #e3e8ee!important}.color-value .el-input__inner{border-radius:4px 0 0 4px}.el-date-editor.el-input{width:100%!important}.el-loading-mask{background-color:hsla(0,0%,100%,.4)!important}.dialog-ec .el-dialog__header{padding:16px;border-bottom:1px solid #e7ecec;position:relative}.dialog-ec .el-dialog__body{padding-top:16px;padding-bottom:6px}.dialog-goods .el-dialog__body,.dialog-picture .el-dialog__body{position:relative;height:43.6rem}.custom-uploader.zindex-1 .el-upload{z-index:-1}.swiper-lazy-preloader{width:22px!important;height:22px!important;margin-left:-11px;margin-top:-11px}.el-checkbox__inner{z-index:0!important}@media only screen and (max-width:1540px){.dialog-goods .el-dialog__body,.dialog-picture .el-dialog__body{height:37rem}}@media only screen and (max-width:1440px){.dialog-goods .el-dialog__body,.dialog-picture .el-dialog__body{height:31rem}}.form-group--remak{margin-top:-1.2rem}.el-loading-spinner .path{stroke:#ff495e!important}.el-loading-spinner .el-loading-text{color:#ff495e!important}", ""]);

// exports


/***/ }),

/***/ 150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('home')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(143);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(68)("d70a3cf2", content, true);

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "public/img/default-img.fe203b8.jpg";

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var Home = function Home() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 196));
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Home: Home
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(28);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',

  store: __WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_modules__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_dialogPicture__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_dialogUrl__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_dialogGoods__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_pageList__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__local_config__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__api_modules__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__api_dialogPicture__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__api_dialogUrl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__api_dialogGoods__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__api_pageList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__local_config__["a"]; });










/***/ }),

/***/ 21:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_global__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_seamlessScroll__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_color_update__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_arr_remove__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_date_format__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lazyload__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_lazyload__);













 false ? Vue.prototype.release = false : __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.release = true;
window.ROOT_PIC = "http://10.10.10.14";

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('href', __WEBPACK_IMPORTED_MODULE_2__directives_global__["a" /* href */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('box-product-w', __WEBPACK_IMPORTED_MODULE_2__directives_global__["b" /* boxProductW */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('seamless-scroll', __WEBPACK_IMPORTED_MODULE_3__directives_seamlessScroll__["a" /* default */]);

if (!window.ROOT_URL) window.ROOT_URL = '/dsc_mall/mobile/';

if (!window.PC_URL) window.PC_URL = '/dsc_mall/';

if (!__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.release) {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.url = function (module) {
    return '/mobile/index.php?m=' + module;
  };
  window.getUrl = function (module) {
    return '/mobile/index.php?m=' + module;
  };
} else {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.url = function (module) {
    return window.ROOT_URL + 'index.php?m=' + module;
  };
  window.getUrl = function (module) {
    return window.ROOT_URL + 'index.php?m=' + module;
  };
}

String.prototype.colorRgb = __WEBPACK_IMPORTED_MODULE_4_mixins_color_update__["a" /* default */].colorRgb;

String.prototype.trims = function () {
  if (this != "" || !this) {
    return this.replace(/\s+/g, "");
  }
};

Array.prototype.remove = __WEBPACK_IMPORTED_MODULE_5_mixins_arr_remove__["a" /* default */].remove;

Date.prototype.format = __WEBPACK_IMPORTED_MODULE_6_mixins_date_format__["a" /* default */].format;

if (!sessionStorage.opened && sessionStorage.getItem('aPicture')) {
  sessionStorage.removeItem('aPicture');
}

window.apiAuthority = "api";
if (window.shopInfo.authority) {
  window.apiAuthority = "view";
} else if (window.shopInfo.ruid != 0 && !window.shopInfo.authority) {
  window.apiAuthority = "apiSeller";
} else {
  window.apiAuthority = "api";
}

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_lazyload___default.a, {
  preLoad: 1.3,
  error: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.release ? window.ROOT_URL + 'public/img/default-img.fe203b8.jpg' : __webpack_require__(19),
  loading: __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.release ? window.ROOT_URL + 'public/img/default-img.fe203b8.jpg' : __webpack_require__(19),
  attempt: 1
});

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_dashboard__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dialog_url__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialog_picture__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dialog_goods__ = __webpack_require__(62);










__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var debug = "production" !== 'production';
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
    strict: debug,
    state: {
        modules: [],
        pageList: [],
        customPageList: [],
        pageSetting: {
            ruid: -1,
            modulesId: -1,
            type: "",
            default: ""
        },
        shopInfo: {
            searchStoreData: {
                allValue: {
                    searchValue: "",
                    bgColor: "",
                    tenKey: ""
                },
                isSuspendSel: "1",
                isPositionSel: "0",
                isMessageSel: "0"
            },
            lineData: {
                allValue: {
                    height: 4,
                    bgColor: ""
                }
            },
            titleData: {
                allValue: {
                    title: "产品列表",
                    fitTitle: "",
                    dateTime: "",
                    author: "",
                    bgColor: ""
                },
                list: [{
                    url: window.ROOT_URL + 'index.php?m=store&a=pro_list&ru_id=' + window.shopInfo.ruid,
                    urlCatetory: "",
                    urlName: "",
                    desc: "更多"
                }],
                isDate: "0",
                isStyleSel: "2",
                isPositionSel: "0"
            },
            productData: {
                allValue: {
                    number: 10,
                    scrollNumber: 3,
                    selectGoodsId: [],
                    categorySOption: '',
                    brandSelect: ''
                },
                isStyleSel: "0",
                isSizeSel: "1",
                tagSelList: ["0", "1", "2"],
                isModuleSel: "0"
            }
        }
    },
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
    modules: {
        namespaced: true,
        dashboard: __WEBPACK_IMPORTED_MODULE_5__modules_dashboard__["a" /* default */],
        dialogUrl: __WEBPACK_IMPORTED_MODULE_6__modules_dialog_url__["a" /* default */],
        dialogPicture: __WEBPACK_IMPORTED_MODULE_7__modules_dialog_picture__["a" /* default */],
        dialogGoods: __WEBPACK_IMPORTED_MODULE_8__modules_dialog_goods__["a" /* default */]
    }
});

var aHot = ['./actions', './mutations', './getters', './modules/dashboard', './modules/dialog-url', './modules/dialog-picture', './modules/dialog-goods'];

if (false) {
    module.hot.accept(aHot, function () {
        store.hotUpdate({
            actions: require('./actions'),
            mutations: require('./mutations'),
            getters: require('./getters'),
            modules: {
                dashboard: require('./modules/dashboard'),
                dialogUrl: require('./modules/dialog-url'),
                dialogPicture: require('./modules/dialog-picture'),
                dialogGoods: require('./modules/dialog-goods')
            }
        });
    });
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_MODULE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_PAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return UPDATE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ADD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REMOVE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SEARCH_PAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return REMOVE_MENU_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return UPDATE_PAGE_PIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_DOC_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NAV_ENTER_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return NAV_LEAVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NAV_HIDDEN_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ADD_MODULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_MODULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return REMOVE_MODULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REMOVE_ALL_MODULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return IS_SHOW_EDIT_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SORT_MODULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_RADIO_SEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_TEXT; });
/* unused harmony export UPDATE_LIST_TEXT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return REMOVE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ADD_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return IS_UPDATE_MODULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return UPDATE_SETTING_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_DIALOG_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ON_OFF_DIALOG_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_MODULES_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_DIALOG_PICTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_DIALOG_PICTURE_THUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ON_OFF_DIALOG_PICTURE; });
/* unused harmony export SET_MODULES_PICTURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ONE_MORE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ADD_LIST_PICTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_PICTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TAB_THUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ON_OFF_DIALOG_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DIALOG_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_DIALOG_SEL_GOODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_SEL_GOODS; });
var SET_MODULE_INFO = 'setModuleInfo';
var SET_PAGE_LIST = 'setPageList';
var UPDATE_PAGE = 'updatePage';
var ADD_PAGE = 'addPage';
var REMOVE_PAGE = 'removePage';
var SEARCH_PAGE_LIST = 'searchPageList';
var UPDATE_PAGE_PIC = "updatePagePic";

var SET_DOC_CONFIG = 'dashboard/setDocConfig';
var NAV_ENTER_TAB = 'dashboard/navHoverTab';
var NAV_LEAVE_TAB = 'dashboard/navOutTab';
var NAV_HIDDEN_TAB = 'dashboard/navHiddenTab';
var ADD_MODULES = 'dashboard/addModules';
var UPDATE_MODULES = 'dashboard/updateModules';
var REMOVE_MODULES = 'dashboard/removeModules';
var REMOVE_ALL_MODULES = 'dashboard/removeAllModules';
var IS_SHOW_EDIT_COMPONENT = 'dashboard/isShowEditComponent';
var SORT_MODULES = 'dashboard/sortModules';
var UPDATE_RADIO_SEL = 'dashboard/updateRadioSel';
var UPDATE_TEXT = 'dashboard/updateText';
var UPDATE_LIST_TEXT = 'dashboard/updateListText';
var REMOVE_LIST = 'dashboard/removeList';
var ADD_LIST = 'dashboard/addList';
var REMOVE_MENU_URL = 'dashboard/removeMenuUrl';
var IS_UPDATE_MODULES = 'dashboard/isUpdateModules';
var UPDATE_SETTING_ACTIVE = 'dashboard/updateSettingActive';

var SET_DIALOG_URL = 'dialogUrl/setDialogUrl';
var ON_OFF_DIALOG_URL = 'dialogUrl/onOffDialogUrl';
var SET_MODULES_URL = 'dialogUrl/setModulesUrl';

var SET_DIALOG_PICTURE = "dialogPicture/setDialogPicture";
var SET_DIALOG_PICTURE_THUMB = "dialogPicture/setDialogPictureThumb";
var ON_OFF_DIALOG_PICTURE = "dialogPicture/onOffDialogPicture";
var SET_MODULES_PICTURE = "dialogPicture/setModulesPicture";
var ONE_MORE_SELECT = "dialogPicture/oneMoreSelect";
var ADD_LIST_PICTURE = "dialogPicture/addListPicture";
var UPDATE_PICTURE = "dialogPicture/updatePicture";
var TAB_THUMB = "dialogPicture/tabThumb";

var ON_OFF_DIALOG_GOODS = 'dialogGoods/onOffDialogGoods';
var SET_DIALOG_GOODS = 'dialogGoods/setDialogGoods';
var SELECT_GOODS = 'dialogGoods/SelectGoods';
var SET_DIALOG_SEL_GOODS = 'dialogGoods/setDialogSelGoods';
var REMOVE_SELECT = 'dialogGoods/removeSelect';
var CLEAR_SEL_GOODS = 'dialogGoods/clearSelGoods';



/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);




function getGoods(o, oF) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(getUrl('console&c=api&a=search'), __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
        cat_id: o.catId || '',
        brand_id: o.brandId || '',
        pageSize: o.pageSize || 15,
        type: o.type || '',
        keyword: o.kwords || '',
        currentPage: o.currentPage || 1
    }));
}

function getGoodsSel(o) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=product'), __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
        number: o.number,
        goods_id: o.selectGoodsId.join(',') || '',
        currentPage: o.currentPage,
        pageSize: o.pageSize
    }));
}

/* harmony default export */ __webpack_exports__["a"] = ({
    getGoods: getGoods,
    getGoodsSel: getGoodsSel
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function format(fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12,
        "H+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds() };
    var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468" : "") + week[this.getDay() + ""]);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return fmt;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    format: format
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return conversion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return oldSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);





var getOldData = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (reslove, reject) {
                            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=keep')).then(function (_ref2) {
                                var _ref2$data = _ref2.data,
                                    data = _ref2$data.data,
                                    error = _ref2$data.error;

                                if (error == 0 && data != "false") {
                                    console.log(123);
                                    var sModules = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(conversion(JSON.parse(data)));
                                    reslove(sModules);
                                } else {
                                    reslove(false);
                                }
                            });
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getOldData() {
        return _ref.apply(this, arguments);
    };
}();

var oldSave = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var sModules;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return getOldData();

                    case 2:
                        sModules = _context2.sent;

                        if (!sModules) {
                            _context2.next = 5;
                            break;
                        }

                        return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=oldSave'), __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({
                            data: sModules
                        })));

                    case 5:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function oldSave() {
        return _ref3.apply(this, arguments);
    };
}();



function conversion(v1) {
    var v2 = [];
    v1.forEach(function (item) {
        var module = item.module,
            setting = item.setting,
            data = item.data;

        switch (module) {
            case "search":
                v2.push({
                    module: "search",
                    setting: setting ? 1 : 0,
                    data: {
                        allValue: {
                            searchValue: data.text,
                            fontColor: "",
                            bgColor: data.headerStyle.bgStyle,
                            tenKey: data.key
                        },
                        isSuspendSel: data.isFixedSel,
                        isPositionSel: data.isLocationSel,
                        isMessageSel: data.isMessageSel
                    }
                });
                break;
            case "picture":
                v2.push({
                    module: "slide",
                    setting: setting ? 1 : 0,
                    data: {
                        list: function () {
                            var arr = [];
                            var i = 0;
                            if (data.imgList) {
                                if (data.imgList.length > 0) {
                                    data.imgList.forEach(function (itemList) {
                                        arr.push({
                                            desc: itemList.desc,
                                            url: itemList.link,
                                            urlCatetory: "自定义页面",
                                            urlName: i++,
                                            img: itemList.img
                                        });
                                    });
                                }
                            }
                            return arr;
                        }(),
                        isStyleSel: data.isStyleSel,
                        isSizeSel: data.isSizeSel
                    }
                });
                break;
            case "title":
                v2.push({
                    module: "title",
                    setting: setting ? 1 : 0,
                    data: {
                        allValue: {
                            author: data.wxStyle.author,
                            bgColor: data.traditionStyle.bgStyle,
                            dateTime: function () {
                                if (data.isStyleSel == 0) {
                                    if (new Date(data.traditionStyle.fitTitle) != "Invalid Date") {
                                        return data.traditionStyle.fitTitle;
                                    } else {
                                        return "";
                                    }
                                } else if (data.isStyleSel == 1) {
                                    if (new Date(data.traditionStyle.fitTitle) != "Invalid Date") {
                                        return data.traditionStyle.fitTitle;
                                    } else {
                                        return "";
                                    }
                                }
                            }(),
                            fitTitle: data.traditionStyle.fitTitle,
                            title: data.title
                        },
                        list: function () {
                            if (data.isStyleSel == 0) {
                                return [{
                                    desc: data.traditionStyle.linkTitle,
                                    url: data.traditionStyle.link,
                                    urlCatetory: "自定义页面",
                                    urlName: "1"
                                }];
                            } else if (data.isStyleSel == 1) {
                                return [{
                                    desc: data.wxStyle.linkTitle,
                                    url: data.wxStyle.link,
                                    urlCatetory: "自定义页面",
                                    urlName: "1"
                                }];
                            }
                        }(),
                        isDate: function () {
                            if (new Date(data.traditionStyle.fitTitle) != "Invalid Date") {
                                return "1";
                            } else {
                                return "0";
                            }
                        }(),
                        isStyleSel: data.isStyleSel,
                        isPositionSel: function () {
                            var n = void 0;
                            switch (data.isShowStyle) {
                                case "text-let":
                                    n = "0";
                                    break;
                                case "text-center":
                                    n = "1";
                                    break;
                                case "text-right":
                                    n = "2";
                                    break;
                                default:
                                    n = "0";
                                    break;
                            }
                            return n;
                        }()
                    }
                });
                break;
            case "line":
                v2.push({
                    module: "line",
                    setting: setting ? 1 : 0,
                    data: {
                        allValue: {
                            bgColor: data.bgColor,
                            height: 1
                        }
                    }
                });
                break;
            case "blank":
                v2.push({
                    module: "line",
                    setting: setting ? 1 : 0,
                    data: {
                        allValue: {
                            height: data.valueHeight / 16
                        }
                    }
                });
                break;
            case "nav":
                v2.push({
                    module: "nav",
                    setting: setting ? 1 : 0,
                    data: {
                        list: function () {
                            var arr = [];
                            var i = 0;
                            if (data.imgList) {
                                if (data.imgList.length > 0) {
                                    data.imgList.forEach(function (itemList) {
                                        arr.push({
                                            desc: itemList.desc,
                                            url: itemList.link,
                                            img: itemList.img,
                                            urlCatetory: "自定义页面",
                                            urlName: i++
                                        });
                                    });
                                }
                            }

                            return arr;
                        }(),
                        isNumberSel: Number(data.isStyleSel) + 2,
                        isStyleSel: "1",
                        isDescSel: data.isTextSel,
                        isIconSel: "0",
                        styleSelList: function () {
                            var arr = [];
                            if (data.isGapSel) {
                                if (data.isGapSel.length > 0) {
                                    data.isGapSel.forEach(function (itemGap) {
                                        arr.push(itemGap);
                                    });
                                }
                                if (data.isBorderSel == 0) {
                                    arr.push("2");
                                }
                            }
                            return arr;
                        }()

                    }
                });
                break;
            case "spike":
                v2.push({
                    module: "count-down",
                    setting: setting ? 1 : 0,
                    data: {
                        allValue: {
                            endTime: data.endTime,
                            number: 10,
                            spikeDesc: "",
                            titleImg: "../data/gallery_album/original_img/5951ceab15b33.jpg"
                        },
                        isStyleSel: "0"
                    }
                });
                break;
            case "announcement":
                v2.push({
                    module: "announcement",
                    setting: setting ? 1 : 0,
                    data: {
                        allValue: {
                            announContent: "",
                            img: data.icon
                        },
                        isDateSel: "0",
                        isStyleSel: "0"
                    }
                });
                break;
            case "product":
                v2.push({
                    module: "product",
                    setting: setting ? 1 : 0,
                    data: {
                        allValue: {
                            number: data.number
                        },
                        isStyleSel: data.isShowModule ? data.isShowModule : "0",
                        isSizeSel: data.isStyleSel,
                        isModuleSel: function () {
                            var s = "";
                            switch (data.isShowMod) {
                                case "best":
                                    s = "0";
                                    break;
                                case "new":
                                    s = "1";
                                    break;
                                case "hot":
                                    s = "2";
                                    break;
                                default:
                                    break;
                            }
                            return s;
                        }(),
                        tagSelList: function () {
                            var arr = [];
                            if (data.isTagSel) {
                                if (data.isTagSel.length > 0) {
                                    data.isTagSel.forEach(function (item) {
                                        arr.push(item);
                                    });
                                }
                            }
                            arr.push("2");
                            return arr;
                        }()
                    }
                });
                break;
            case "list":
                v2.push({
                    module: "nav",
                    setting: setting ? 1 : 0,
                    data: {
                        isIconSel: "1",
                        isNumberSel: "5",
                        isStyleSel: "0",
                        list: function () {
                            var arr = [];
                            var i = 0;
                            if (data.contListBox) {
                                if (data.contListBox.length > 0) {
                                    data.contListBox.forEach(function (itemBox) {
                                        arr.push({
                                            desc: itemBox.contName,
                                            url: itemBox.contUrl,
                                            img: "",
                                            urlCatetory: "自定义页面",
                                            urlName: i++
                                        });
                                    });
                                }
                            }
                            return arr;
                        }(),
                        styleSelList: []
                    }
                });
                break;
            case "tabdown":
                v2.push({
                    module: "tab-down",
                    setting: setting ? 1 : 0,
                    data: {
                        list: function () {
                            var arr = [];
                            var i = 0;
                            if (data.imgList) {
                                if (data.imgList.length > 0) {
                                    data.imgList.forEach(function (itemList) {
                                        arr.push({
                                            desc: itemList.desc,
                                            img: itemList.img,
                                            url: itemList.link,
                                            urlCatetory: "自定义页面",
                                            urlName: i++
                                        });
                                    });
                                }
                            }
                            return arr;
                        }()
                    }
                });
                break;
            default:
                break;
        }
    });
    return v2;
}



/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_message_box_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_loading_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_base_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_qs__);












var loadingInstance = void 0;

function getAlbum() {
    return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=thumb'), __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify({
        type: "thumb",
        ruid: window.shopInfo.ruid
    }));
}

function getPriture(albumId, o, oF) {
    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=thumb'), __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify({
        type: "img",
        currentPage: o.currentPage,
        pageSize: o.pageSize,
        album_id: albumId
    })).then(function (res) {
        setTimeout(function () {
            res.data.img.forEach(function (v) {
                v.bActive = false;
            });
            oF.setDialogPicture({
                data: res.data,
                oneOrMore: o.oneOrMore,
                maxLength: o.maxLength,
                residueLength: o.residueLength
            });
            loadingInstance.close();
        }, 100);
    }).then(function (res) {
        oF.onOffDialogPicture();
    }).catch(function (err) {
        console.error(err);
    });
}

function getDialog(o, oF) {
    var albumId = 0;
    var albumName = "";
    loadingInstance = __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_loading___default.a.service({ target: "body", text: "加载中……" });
    if (o.albumId) {
        albumId = o.albumId;
        getPriture(albumId, o, oF);
    } else {
        getAlbum().then(function (res) {
            var aThumb = res.data.thumb;
            if (aThumb) {
                if (aThumb.length > 0) {
                    albumId = aThumb[0].album_id;
                    albumName = aThumb[0].name;
                }
                aThumb.map(function (v, i) {
                    i == 0 ? v.bActive = true : v.bActive = false;
                });
                oF.setDialogPictureThumb({
                    thumb: aThumb,
                    albumId: albumId,
                    albumName: albumName
                });
                return { albumId: albumId };
            }
        }).then(function (res) {
            loadingInstance.close();
            if (res) {
                getPriture(res.albumId, o, oF);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_message_box___default.a.confirm('暂无相册，是否添加？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=makeGallery'), __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify({
                        ruid: window.shopInfo.ruid
                    })).then(function (_ref) {
                        var album_id = _ref.data.album_id;

                        __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a.info("添加成功！");
                    });
                }).catch(function (err) {
                    console.error(err);
                });
            }
        }).catch(function (err) {
            console.error(err);
        });
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    getDialog: getDialog
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_loading_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);








var son = [];
function formatDialogUrl(url) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var lev = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(url), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var isTrue = true;
            var cat_id = item.cat_id;
            if (item.parent_id == id) {
                __WEBPACK_IMPORTED_MODULE_5_vue___default.a.set(item, "lev", lev);
                son.push(item);
                formatDialogUrl(url, item.cat_id, lev + 1);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return son;
}

function getDialog(o, oF) {
    if (o.type != "custom") {
        var loadingInstance = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.service({ target: "body", text: "加载中……" });
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=url'), __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify({
            type: o.type,
            ruid: window.shopInfo.ruid,
            currentPage: o.currentPage,
            pageSize: o.pageSize
        })).then(function (res) {
            setTimeout(function () {
                res.data.url.forEach(function (item) {
                    if (item.url.startsWith(window.ROOT_URL)) {
                        item.url = item.url.slice(window.ROOT_URL.length);
                    }
                });
                var formatData = formatDialogUrl(res.data.url);
                res.data.url = formatData;
                oF.setDialogUrl(res.data);
                son = [];
                loadingInstance.close();
            }, 100);
        }).then(function (res) {
            oF.onOffDialogUrl();
        }).catch(function (err) {
            console.error(err);
        });
    } else {
        oF.onOffDialogUrl();
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    getDialog: getDialog
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_loading_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_base_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);










var getModules = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(o, oF) {
        var loadingInstance;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        loadingInstance = __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_loading___default.a.service({ fullscreen: true, text: "玩命加载中……" });

                        __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=view'), __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify(o)).then(function (res) {
                            if (!res.data.view) {
                                loadingInstance.close();
                                location.href = '' + window.ROOT_URL;
                                return;
                            }
                            setTimeout(function () {
                                oF.getModule({
                                    moduleData: res.data.view.data,
                                    id: o.id,
                                    title: o.title,
                                    type: res.data.view.type,
                                    default: res.data.view.default
                                });
                                loadingInstance.close();
                            }, 100);
                        }).catch(function (err) {
                            console.error(err);
                        });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getModules(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();





function saveModules(o) {
    var thisO = {};
    if (o.title && o.title) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(thisO, {
            title: o.title,
            ruid: o.ruid
        });
    }
    if (o.modulesId && o.modules) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(thisO, {
            id: o.modulesId,
            data: o.modules
        });
    }
    return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=save'), __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify(thisO));
}

function tipsSaveModules(o) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box___default.a.confirm("当前页面数据有改动，是否保存？", "提示", {
            confirmButtonText: '保存',
            cancelButtonText: '丢弃',
            type: 'warning'
        }).then(function () {
            saveModules(o).then(function (_ref2) {
                var error = _ref2.data.error;

                error == 1 ? reject(false) : resolve(true);
            });
        }).catch(function (err) {
            reject("messageBox catch");
        });
    });
}

function removeModules(o) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box___default.a.confirm('\u5220\u9664 "' + o.title + '" \u9875\u9762\u5C06\u65E0\u6CD5\u6062\u590D\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function (action) {
            __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=del'), __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify({
                id: o.id
            })).then(function (_ref3) {
                var error = _ref3.data.error;

                error == 1 ? reject(false) : resolve(true);
            });
        }).catch(function (err) {
            reject("messageBox catch");
        });
    });
}

function updateModulesTitle(o) {
    return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=title'), __WEBPACK_IMPORTED_MODULE_9_qs___default.a.stringify({
        id: o.id,
        title: o.title
    }));
}

/* harmony default export */ __webpack_exports__["a"] = ({
    getModules: getModules,
    saveModules: saveModules,
    tipsSaveModules: tipsSaveModules,
    removeModules: removeModules,
    updateModulesTitle: updateModulesTitle
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_js_data_conversion__ = __webpack_require__(43);




var getPageList = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(o) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_assets_js_data_conversion__["a" /* oldSave */])();

                    case 2:
                        return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (reslove, reject) {
                            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(getUrl('console&c=' + window.apiAuthority + '&a=view'), __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({
                                ruid: o.ruid,
                                default: o.sDefault,
                                number: o.number
                            })).then(function (res) {
                                reslove(res);
                            }).catch(function (err) {
                                console.error(err);
                            });
                        }));

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getPageList(_x) {
        return _ref.apply(this, arguments);
    };
}();






/* harmony default export */ __webpack_exports__["a"] = ({
    getPageList: getPageList
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var localUrl = "http://10.10.10.14:3000/";
var pageInfo = {
    headerMenu: {
        pageListTitle: {
            icon: "page",
            isActive: true,
            isShow: true
        },
        globaSettings: {
            text: "全局配置",
            isActive: false,
            isShow: false
        },
        menuComponent: [{
            text: "布局",
            isActive: false,
            isShow: true,
            subComponent: [{
                icon: "line",
                text: "辅助线",
                module: "line",
                type: "all",
                isShow: true
            }, {
                icon: "blank",
                text: "辅助空白",
                module: "blank",
                type: "all",
                isShow: true
            }, {
                icon: "magic-cube",
                text: "魔方",
                module: "magic-cube",
                type: "all",
                isShow: false
            }]
        }, {
            text: "文本",
            isActive: false,
            isShow: true,
            subComponent: [{
                text: "标题",
                icon: "title",
                module: "title",
                type: "all",
                isShow: true
            }, {
                text: "段落",
                icon: "passage",
                module: "passage",
                type: "all",
                isShow: false
            }, {
                text: "富文本",
                icon: "rick-text",
                module: "rick-text",
                type: "all",
                isShow: false
            }, {
                text: "公告",
                icon: "announcement",
                module: "announcement",
                type: "all",
                isShow: true
            }, {
                text: "文字导航",
                icon: "text-nav",
                module: "textNav",
                type: "all",
                isShow: false
            }]
        }, {
            text: "图片",
            isActive: false,
            isShow: true,
            subComponent: [{
                icon: "img-nav",
                text: "图片导航",
                module: "nav",
                type: "all",
                isShow: true
            }, {
                icon: "slide",
                text: "幻灯片",
                module: "slide",
                type: "all",
                isShow: true
            }, {
                icon: "jigsaw",
                text: "拼图",
                module: "jigsaw",
                type: "all",
                isShow: true
            }]
        }, {
            text: "功能",
            isActive: false,
            isShow: true,
            subComponent: [{
                icon: "count-down",
                text: "倒计时",
                module: "count-down",
                type: "platform",
                isShow: true
            }, {
                icon: "coupon",
                text: "优惠券",
                module: "coupon",
                type: "all",
                isShow: false
            }, {
                icon: "product-list",
                text: "商品列表",
                module: "product",
                type: "all",
                isShow: true
            }, {
                icon: "search",
                text: "搜索",
                module: "search",
                type: "platform",
                isShow: true
            }, {
                icon: "button",
                text: "按钮",
                module: "button",
                type: "all",
                isShow: false
            }, {
                icon: "store",
                text: "店铺街",
                module: "store",
                type: "platform",
                isShow: true
            }, {
                icon: "tab-down",
                text: "导航",
                module: "tab-down",
                type: "platform",
                isShow: true
            }]
        }]
    },
    pageListTool: {
        system: {
            text: "系统默认"
        },
        custom: {
            text: "自定义"
        },
        search: {
            icon: "search",
            text: "页面搜索"
        }
    },
    editArea: {
        text: "编辑区域",
        function: {
            clear: {
                text: "清空",
                icon: "clear"
            },
            save: {
                text: "存储",
                icon: "save"
            },
            restore: {
                text: "还原",
                icon: "restore"
            }
        },
        compontentTool: {
            spread: "arrow",
            sort: "sort-arrow"
        }
    },
    previewArea: {
        text: "预览区域",
        function: {
            release: {
                text: "发布",
                icon: "release"
            }
        }
    },
    otherArea: {
        QRCodeText: "扫码手机预览",
        function: {
            import: "本地导入",
            export: "导出至本地"
        },
        prompt: {
            headline: "温馨提示",
            text: "手机扫描二维码，即可在手机进行观看页面效果",
            http: {
                text: "链接名称",
                link: "http://www.ectouch.cn"
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    localUrl: localUrl,
    pageInfo: pageInfo
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return href; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return boxProductW; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var href = {
    bind: function bind(el, binding) {
        var _binding$value = binding.value,
            sUrl = _binding$value.sUrl,
            preview = _binding$value.preview;

        preview || sUrl == "" || !sUrl ? el.href = "javascript:;" : el.href = binding.value.sUrl;
    }
};

var boxProductW = {
    bind: function bind(el, binding) {
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
            var _binding$value2 = binding.value,
                bSizeSel = _binding$value2.bSizeSel,
                preview = _binding$value2.preview,
                type = _binding$value2.type;

            if (bSizeSel != 2 && !preview || type == "store") {
                el.style.height = el.offsetWidth + "px";
                el.style.lineHeight = el.offsetWidth + "px";
            }
        });
    }
};



/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var speed = 50;
function cloneInnerHtml(el, binding) {
    var parentElWidth = el.parentNode.offsetWidth,
        childrenElWidth = el.querySelector(".seamless-scroll-wrapper").offsetWidth,
        elWidth = childrenElWidth * 2;
    if (!binding.value.preview && parentElWidth < childrenElWidth) {
        el.style.width = elWidth + 1 + "px";
        el.innerHTML += el.innerHTML;
        clearInterval(window[binding.value.winObj]);
        window[binding.value.winObj] = setInterval(marquee, speed, el);
    }
}

function marquee(el) {
    el.style.left = el.offsetLeft - 1 + "px";
    if (el.offsetLeft < -(el.offsetWidth / 2)) {
        el.style.left = 0;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    bind: function bind(el, binding) {
        window[binding.value.winObj] = null;
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
            cloneInnerHtml(el, binding);
        });
    },
    update: function update(el, binding) {
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
            cloneInnerHtml(el, binding);
        });
    }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function remove(val, number) {
    var arrIndex = this.indexOf(val),
        num = Number(number);
    if (num > this.length) num = this.length;
    if (arrIndex != -1 && num > 0) {
        this.splice(arrIndex, num);
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    remove: remove
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;

function colorRgb(opacity, bArr) {
    var sColor = this.toLowerCase();
    if (sColor && reg.test(sColor)) {
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt(sColor.slice(i, i + 2), 16));
        }
        if (bArr) return sColorChange;
        return opacity == -1 ? "rgb(" + sColorChange.join(",") + ")" : "rgba(" + sColorChange.join(",") + "," + opacity + ")";
    } else {
        return val;
    }
}
/* harmony default export */ __webpack_exports__["a"] = ({
    colorRgb: colorRgb
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_type_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
    setPageList: function setPageList(_ref, o) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_config__["f" /* apiPageList */].getPageList(o));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    setModuleInfo: function setModuleInfo(_ref2, o) {
        var commit = _ref2.commit;

        __WEBPACK_IMPORTED_MODULE_3_config__["a" /* apiModules */].getModules(o, {
            getModule: function getModule(o) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["G" /* SET_MODULE_INFO */], o);
            }
        });
    },
    initPageModule: function initPageModule(_ref3, o) {
        var _this2 = this;

        var dispatch = _ref3.dispatch,
            commit = _ref3.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var defaultModuleId, modulesTitle;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            defaultModuleId = -1;
                            modulesTitle = "";
                            _context2.next = 4;
                            return dispatch('setPageList', o).then(function (_ref4) {
                                var view = _ref4.data.view;

                                view.forEach(function (item) {
                                    if (!item.pic) item.pic = "";
                                    if (!item.thumb_pic) item.thumb_pic = "";
                                });
                                commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["H" /* SET_PAGE_LIST */], {
                                    pageList: view
                                });
                                var pageListLen = view.length;
                                if (pageListLen > 0) {
                                    for (var i = 0; i < pageListLen; i++) {
                                        if (view[i].type == "index" && view[i].default == 1 || view[i].type == "store" && view[i].default == 1) {
                                            defaultModuleId = view[i].id;
                                            break;
                                        }
                                    }
                                }
                            });

                        case 4:

                            if (defaultModuleId > -1) {
                                dispatch('setModuleInfo', {
                                    id: defaultModuleId
                                });
                            }

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    updatePage: function updatePage(_ref5, o) {
        var commit = _ref5.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["I" /* UPDATE_PAGE */], o);
    },
    removePage: function removePage(_ref6, o) {
        var commit = _ref6.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["K" /* REMOVE_PAGE */], o);
    },
    addPage: function addPage(_ref7, o) {
        var commit = _ref7.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["J" /* ADD_PAGE */], o);
    },
    isEqualTitle: function isEqualTitle(_ref8, o) {
        var commit = _ref8.commit,
            rootState = _ref8.rootState;

        var aPageList = rootState.pageList;
        var pageListLen = aPageList.length;
        var trimValue = o.value.trims();
        for (var i = 0; i < pageListLen; i++) {
            if (aPageList[i].id == o.id && aPageList[i].title == trimValue) {
                return true;
            }
        }
        return false;
    },
    searchPageList: function searchPageList(_ref9, o) {
        var commit = _ref9.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["L" /* SEARCH_PAGE_LIST */], o);
    },
    removeMenuUrl: function removeMenuUrl(_ref10, o) {
        var commit = _ref10.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["M" /* REMOVE_MENU_URL */], o);
    },
    updatePagePic: function updatePagePic(_ref11, o) {
        var commit = _ref11.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["N" /* UPDATE_PAGE_PIC */], o);
    },
    setConversionModules: function setConversionModules(_ref12, o) {
        var commit = _ref12.commit;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_type_js__["G" /* SET_MODULE_INFO */], o);
    }
});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
    customPageList: function customPageList(_ref, getters) {
        var customPageListSearch = _ref.customPageListSearch,
            pageList = _ref.pageList;

        return pageList.filter(function (item) {
            return item.default == customPageListSearch.default && item.title.toLowerCase().includes(customPageListSearch.title.toLowerCase());
        });
    }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_type__ = __webpack_require__(3);



var _mutations;







var state = {
    configInfo: {},
    bUpdateModules: false
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["q" /* SET_DOC_CONFIG */], function (state, configInfo) {
    state.configInfo = configInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["r" /* NAV_ENTER_TAB */], function (state, index) {
    var menuCommponent = state.configInfo.headerMenu.menuComponent;
    menuCommponent.map(function (o, i) {
        i == index ? o.isActive = true : o.isActive = false;
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["s" /* NAV_LEAVE_TAB */], function (state, index) {
    var menuCommponent = state.configInfo.headerMenu.menuComponent;
    menuCommponent[index].isActive = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["t" /* NAV_HIDDEN_TAB */], function (state) {
    state.configInfo.headerMenu.menuComponent.forEach(function (item) {
        item.isActive = false;
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["u" /* ADD_MODULES */], function (state, _ref) {
    var rootState = _ref.rootState,
        o = _ref.o;

    console.log(o.module);
    rootState.modules.splice(o.newIndex, 0, o.module);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["v" /* UPDATE_MODULES */], function (state, _ref2) {
    var rootState = _ref2.rootState,
        o = _ref2.o;

    rootState.modules = o.modules;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["w" /* SORT_MODULES */], function (state, _ref3) {
    var rootState = _ref3.rootState,
        o = _ref3.o;

    var currModule = rootState.modules[o.modulesIndex],
        sort = o.sort;
    rootState.modules.splice(o.modulesIndex, 1);
    if (sort == "up") {
        rootState.modules.splice(o.modulesIndex - 1, 0, currModule);
    } else {
        rootState.modules.splice(o.modulesIndex + 1, 0, currModule);
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["x" /* REMOVE_MODULES */], function (state, _ref4) {
    var rootState = _ref4.rootState,
        o = _ref4.o;

    rootState.modules.splice(o.modulesIndex, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["y" /* REMOVE_ALL_MODULES */], function (state, rootState) {
    rootState.modules = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["z" /* IS_SHOW_EDIT_COMPONENT */], function (state, _ref5) {
    var rootState = _ref5.rootState,
        o = _ref5.o;

    var sSetting = rootState.modules[o.modulesIndex].setting;
    '1' == sSetting ? rootState.modules[o.modulesIndex].setting = '0' : rootState.modules[o.modulesIndex].setting = '1';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["A" /* UPDATE_RADIO_SEL */], function (state, _ref6) {
    var rootState = _ref6.rootState,
        o = _ref6.o;

    rootState.modules[o.modulesIndex].data[o.sName] = o.newValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["B" /* ADD_LIST */], function (state, _ref7) {
    var rootState = _ref7.rootState,
        o = _ref7.o;

    var thisModules = rootState.modules[o.modulesIndex];
    delete o["modulesIndex"];
    thisModules.data.list.push(o);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["C" /* REMOVE_LIST */], function (state, _ref8) {
    var rootState = _ref8.rootState,
        o = _ref8.o;

    rootState.modules[o.modulesIndex].data.list.splice(o.listIndex, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["D" /* UPDATE_TEXT */], function (state, _ref9) {
    var rootState = _ref9.rootState,
        o = _ref9.o;

    var data = rootState.modules[o.modulesIndex].data;
    if (!isNaN(o.listIndex)) {
        data.list[o.listIndex].desc = o.newValue;
    } else {
        if (!data[o.dataNext]) {
            data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data, {
                allValue: {}
            });
        }
        if (!data[o.dataNext][o.attrName]) {
            data[o.dataNext] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data.allValue, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, o.attrName, o.newValue));
            return false;
        }
        __WEBPACK_IMPORTED_MODULE_2_Vue__["a" /* default */].set(data.allValue, o.attrName, o.newValue);
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["E" /* UPDATE_SETTING_ACTIVE */], function (state, _ref10) {
    var rootState = _ref10.rootState,
        attrName = _ref10.attrName;

    var bActive = state.configInfo.headerMenu[attrName].isActive;
    state.configInfo.headerMenu[attrName].isActive = !bActive;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_type__["F" /* IS_UPDATE_MODULES */], function (state, bUpdateModules) {
    state.bUpdateModules = bUpdateModules;
}), _mutations);

var actions = {
    setDocConfig: function setDocConfig(_ref11) {
        var commit = _ref11.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["q" /* SET_DOC_CONFIG */], __WEBPACK_IMPORTED_MODULE_3_config__["e" /* localConfig */].pageInfo);
    },
    navEnterTab: function navEnterTab(_ref12, index) {
        var commit = _ref12.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["r" /* NAV_ENTER_TAB */], index);
    },
    navLeaveTab: function navLeaveTab(_ref13, index) {
        var commit = _ref13.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["s" /* NAV_LEAVE_TAB */], index);
    },
    navHiddenTab: function navHiddenTab(_ref14) {
        var commit = _ref14.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["t" /* NAV_HIDDEN_TAB */]);
    },
    updateModules: function updateModules(_ref15, o) {
        var commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["v" /* UPDATE_MODULES */], { rootState: rootState, o: o });
    },
    sortModules: function sortModules(_ref16, o) {
        var commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["w" /* SORT_MODULES */], { rootState: rootState, o: o });
    },
    removeModules: function removeModules(_ref17, o) {
        var commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["x" /* REMOVE_MODULES */], { rootState: rootState, o: o });
    },
    removeAllModules: function removeAllModules(_ref18) {
        var commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["y" /* REMOVE_ALL_MODULES */], rootState);
    },
    isShowEditComponent: function isShowEditComponent(_ref19, o) {
        var commit = _ref19.commit,
            rootState = _ref19.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["z" /* IS_SHOW_EDIT_COMPONENT */], { rootState: rootState, o: o });
    },
    addModules: function addModules(_ref20, o) {
        var commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["u" /* ADD_MODULES */], { rootState: rootState, o: o });
    },
    updateRadioSel: function updateRadioSel(_ref21, o) {
        var commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["A" /* UPDATE_RADIO_SEL */], { rootState: rootState, o: o });
    },
    updateText: function updateText(_ref22, o) {
        var commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["D" /* UPDATE_TEXT */], { rootState: rootState, o: o });
    },
    removeList: function removeList(_ref23, o) {
        var commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["C" /* REMOVE_LIST */], { rootState: rootState, o: o });
    },
    addList: function addList(_ref24, o) {
        var commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["B" /* ADD_LIST */], { rootState: rootState, o: o });
    },
    updateSettingActive: function updateSettingActive(_ref25, attrName) {
        var commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["E" /* UPDATE_SETTING_ACTIVE */], { rootState: rootState, attrName: attrName });
    },
    isUpdateModules: function isUpdateModules(_ref26, bUpdateModules) {
        var commit = _ref26.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_type__["F" /* IS_UPDATE_MODULES */], bUpdateModules);
    }
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_loading_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(2);






var _mutations;







var loadingInstance = void 0;
var state = {
    goodsList: [],

    selGoodsList: [],

    settingType: {
        bShowDialog: false,
        total: 0,
        pageSize: 0,
        currentPage: 0,
        modulesIndex: -1,
        catId: 0,
        brandId: 0,
        type: '',
        brandSelect: '',
        selGoodNum: 0
    },

    selectGoodsType: {
        total: 0,
        pageSize: 0,
        currentPage: 1
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_type__["a" /* ON_OFF_DIALOG_GOODS */], function (state, o) {
    if (o.bShowDialog) {
        state.settingType.bShowDialog = o.bShowDialog;
        state.settingType.modulesIndex = o.modulesIndex;
        state.settingType.brandSelect = o.brandSelect;
        state.settingType.currentPage = o.currentPage;
        state.settingType.catId = o.catId;
        state.settingType.type = o.type;
        state.settingType.pageSize = o.pageSize;
    } else {
        state.settingType.bShowDialog = o.bShowDialog;
    }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_type__["b" /* SET_DIALOG_GOODS */], function (state, o) {
    var modules = o.rootState.modules,
        selectGoodsId = [];

    if (modules[o.modulesIndex].data.allValue.selectGoodsId) {
        selectGoodsId = modules[o.modulesIndex].data.allValue.selectGoodsId;
    } else {
        modules[o.modulesIndex].data.allValue = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, modules[o.modulesIndex].data.allValue, { selectGoodsId: [] });
    }
    o.list.map(function (item) {
        selectGoodsId.map(function (itemId) {
            if (item.goods_id == itemId) {
                item.bActive = true;
            }
        });
    });
    state.goodsList = o.list;
    state.settingType.total = o.total;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_type__["c" /* SELECT_GOODS */], function (state, o) {
    var modules = o.rootState.modules,
        modulesIndex = state.settingType.modulesIndex,
        allValue = modules[modulesIndex].data.allValue;

    console.log('select');
    console.log(modulesIndex);
    if (!state.goodsList[o.index].bActive) {
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(state.goodsList, o.index, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.goodsList[o.index], {
            bActive: true
        }));
        allValue.selectGoodsId.push(state.goodsList[o.index].goods_id);
    } else {
        state.goodsList[o.index].bActive = false;
        var len = allValue.selectGoodsId.length;
        for (var i = 0; i < len; i++) {
            if (state.goodsList[o.index].goods_id == allValue.selectGoodsId[i]) {
                allValue.selectGoodsId.splice(i, 1);
                break;
            }
        }
    }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_type__["d" /* SET_DIALOG_SEL_GOODS */], function (state, o) {
    state.selectGoodsType.pageSize = o.pageSize;
    state.selectGoodsType.currentPage = o.currentPage;
    state.selGoodsList = o.goodslist;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_type__["e" /* REMOVE_SELECT */], function (state, o) {
    var goodsId = o.goodsId,
        pageSize = o.pageSize,
        currentPage = o.currentPage,
        modulesIndex = o.modulesIndex,
        modules = o.rootState.modules,
        selectGoodsId = modules[modulesIndex].data.allValue.selectGoodsId,
        len = selectGoodsId.length;

    for (var i = 0; i < len; i++) {
        if (selectGoodsId[i] == goodsId) {
            selectGoodsId.splice(i, 1);
        }
    }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_type__["f" /* CLEAR_SEL_GOODS */], function (state, o) {
    var modulesIndex = o.modulesIndex,
        modules = o.rootState.modules;

    modules[modulesIndex].data.allValue.selectGoodsId = [];
}), _mutations);

var actions = {
    onOffDialogGoods: function onOffDialogGoods(_ref, o) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_type__["a" /* ON_OFF_DIALOG_GOODS */], o);
    },
    setDialogGoods: function setDialogGoods(_ref2, o) {
        var commit = _ref2.commit,
            rootState = _ref2.rootState;

        console.log(o);
        loadingInstance = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.service({ target: "body", text: "加载中……" });
        __WEBPACK_IMPORTED_MODULE_7_config__["b" /* apiDialogGoods */].getGoods(o).then(function (_ref3) {
            var _ref3$data = _ref3.data,
                list = _ref3$data.list,
                total = _ref3$data.total;

            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_type__["b" /* SET_DIALOG_GOODS */], {
                rootState: rootState,
                modulesIndex: o.modulesIndex,
                list: list,
                total: total
            });
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_type__["a" /* ON_OFF_DIALOG_GOODS */], o);
            setTimeout(function () {
                loadingInstance.close();
            }, 100);
        });
    },
    setDialogSelGoods: function setDialogSelGoods(_ref4, o) {
        var commit = _ref4.commit;

        __WEBPACK_IMPORTED_MODULE_7_config__["b" /* apiDialogGoods */].getGoodsSel(o).then(function (_ref5) {
            var goodslist = _ref5.data.goodslist;

            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_type__["d" /* SET_DIALOG_SEL_GOODS */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, o, {
                goodslist: goodslist
            }));
        });
    },
    selectGoods: function selectGoods(_ref6, o) {
        var commit = _ref6.commit,
            rootState = _ref6.rootState;

        console.log('select');
        console.log(o);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_type__["c" /* SELECT_GOODS */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, o, {
            rootState: rootState
        }));
    },
    removeSelect: function removeSelect(_ref7, o) {
        var commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_type__["e" /* REMOVE_SELECT */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, o, {
            rootState: rootState
        }));
    },
    clearSelGoods: function clearSelGoods(_ref8, o) {
        var commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_type__["f" /* CLEAR_SEL_GOODS */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, o, {
            rootState: rootState
        }));
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_is__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_message_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_base_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(2);







var _mutations;





var state = {
    pictureList: [],
    thumbList: [],
    settingType: {
        allValuesType: "",
        albumId: 0,
        albumName: "",
        bShowDialog: false,
        total: 0,
        pageSize: 0,
        currentPage: 1,
        modulesIndex: -1,
        listIndex: -1,
        selectPicture: -1,
        oneOrMore: "one",
        maxLength: 0,
        residueLength: 0,
        pictureLength: 0
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_type__["g" /* SET_DIALOG_PICTURE */], function (state, o) {
    if (sessionStorage.getItem("aPicture")) {
        JSON.parse(sessionStorage.getItem("aPicture")).forEach(function (v) {
            o.data.img.forEach(function (iV) {
                if (iV.pic_id == v.pic_id) {
                    iV.bActive = true;
                }
            });
        });
    }
    state.pictureList = o.data.img;
    state.settingType.total = o.data.total;
    state.settingType.oneOrMore = o.oneOrMore;
    state.settingType.maxLength = o.maxLength;
    state.settingType.residueLength = o.residueLength;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_type__["h" /* SET_DIALOG_PICTURE_THUMB */], function (state, o) {
    state.settingType.pictureLength = 0;
    state.settingType.albumId = o.albumId;
    state.settingType.albumName = o.albumName;
    state.thumbList = o.thumb;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_type__["i" /* ON_OFF_DIALOG_PICTURE */], function (state, o) {
    if (o.bShowDialog) {
        state.settingType.bShowDialog = o.bShowDialog;
        state.settingType.modulesIndex = o.modulesIndex;
        state.settingType.listIndex = o.listIndex;
        state.settingType.currentPage = o.currentPage;
        state.settingType.pageSize = o.pageSize;
        state.settingType.allValuesType = o.allValuesType;
    } else {
        state.settingType.bShowDialog = o.bShowDialog;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_type__["j" /* ONE_MORE_SELECT */], function (state, o) {
    var sOneOrMore = state.settingType.oneOrMore;
    var nMaxLength = state.settingType.maxLength;
    var nResidueLength = state.settingType.residueLength;
    var picture = state.pictureList[o.listIndex];
    var nActiveNum = 0;
    var aPicture = [];
    if (sOneOrMore == "one") {
        state.pictureList.forEach(function (v) {
            v.bActive = false;
        });
        state.pictureList[o.listIndex].bActive = !state.pictureList[o.listIndex].bActive;
    } else {
        if (sessionStorage.getItem("aPicture")) {
            nActiveNum = JSON.parse(sessionStorage.getItem("aPicture")).length;
        }
        if (nActiveNum >= nResidueLength) {
            if (!state.pictureList[o.listIndex].bActive) {
                __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_message___default.a.error("\u8BE5\u7EC4\u4EF6\u6700\u591A\u53EF\u6DFB\u52A0 " + nMaxLength + " \u5F20\u56FE\u7247");
            }
            state.pictureList[o.listIndex].bActive = false;
        } else {
            state.pictureList[o.listIndex].bActive = !state.pictureList[o.listIndex].bActive;
        }
        if (state.pictureList[o.listIndex].bActive) {
            if (sessionStorage.getItem("aPicture")) {
                var sLocalPicture = sessionStorage.getItem("aPicture");
                aPicture = JSON.parse(sLocalPicture);
                if (!aPicture.find(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_is___default()(item.pic_id, picture.pic_id);
                })) {
                    aPicture.push(picture);
                }
                sessionStorage.setItem("aPicture", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(aPicture));
            } else {
                aPicture.push(picture);
                sessionStorage.setItem("aPicture", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(aPicture));
            }
        } else {
            if (sessionStorage.getItem("aPicture")) {
                var _sLocalPicture = sessionStorage.getItem("aPicture");
                aPicture = JSON.parse(_sLocalPicture);
                aPicture.map(function (v, i) {
                    if (v.pic_id == picture.pic_id) {
                        aPicture.splice(i, 1);
                    }
                });
                sessionStorage.setItem("aPicture", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(aPicture));
            }
        }
    }
    state.settingType.pictureLength = aPicture.length;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_type__["k" /* ADD_LIST_PICTURE */], function (state, _ref) {
    var rootState = _ref.rootState,
        o = _ref.o;

    var nModulesIndex = state.settingType.modulesIndex;
    var moduleData = rootState.modules[nModulesIndex].data;
    o.aSelectPic.forEach(function (v) {
        moduleData.list.push(v);
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_type__["l" /* UPDATE_PICTURE */], function (state, _ref2) {
    var rootState = _ref2.rootState,
        o = _ref2.o;

    var nModulesIndex = state.settingType.modulesIndex;
    var sAllValuesType = state.settingType.allValuesType;
    var moduleData = rootState.modules[nModulesIndex].data;
    if (sAllValuesType) {
        if (o.aSelectPic.length > 0) {
            moduleData.allValue[sAllValuesType] = o.aSelectPic[0].img;
        }
    } else {
        var nListIndex = state.settingType.listIndex;
        if (o.aSelectPic.length > 0) {
            moduleData.list[nListIndex].img = o.aSelectPic[0].img;
        }
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_type__["m" /* TAB_THUMB */], function (state, o) {
    state.thumbList.forEach(function (v) {
        v.bActive = false;
    });
    state.settingType.albumName = o.albumName;
    state.settingType.albumId = o.albumId;
    state.thumbList[o.index].bActive = true;
}), _mutations);

var actions = {
    onOffDialogPicture: function onOffDialogPicture(_ref3, o) {
        var commit = _ref3.commit;

        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["i" /* ON_OFF_DIALOG_PICTURE */], o);
    },
    setDialogPicture: function setDialogPicture(_ref4, o) {
        var commit = _ref4.commit;

        __WEBPACK_IMPORTED_MODULE_7_config__["c" /* apiDialogPicture */].getDialog(o, {
            setDialogPicture: function setDialogPicture(o) {
                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["g" /* SET_DIALOG_PICTURE */], o);
            },
            onOffDialogPicture: function onOffDialogPicture() {
                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["i" /* ON_OFF_DIALOG_PICTURE */], o);
            },
            setDialogPictureThumb: function setDialogPictureThumb(o) {
                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["h" /* SET_DIALOG_PICTURE_THUMB */], o);
            }
        });
    },
    oneMoreSelect: function oneMoreSelect(_ref5, o) {
        var commit = _ref5.commit;

        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["j" /* ONE_MORE_SELECT */], o);
    },
    addListPicture: function addListPicture(_ref6, o) {
        var commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["k" /* ADD_LIST_PICTURE */], { rootState: rootState, o: o });
    },
    updatePicture: function updatePicture(_ref7, o) {
        var commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["l" /* UPDATE_PICTURE */], { rootState: rootState, o: o });
    },
    tabThumb: function tabThumb(_ref8, o) {
        var commit = _ref8.commit;

        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_type__["m" /* TAB_THUMB */], o);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_type__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(2);


var _mutations;





var state = {
    urlList: [],
    settingType: {
        type: "",
        bShowDialog: false,
        total: 0,
        pageSize: 0,
        currentPage: 1,
        modulesIndex: 0,
        listIndex: 0,
        dialogTitle: ""
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_type__["n" /* SET_DIALOG_URL */], function (state, o) {
    state.urlList = o.data.url;
    state.settingType.total = o.data.total;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_type__["o" /* ON_OFF_DIALOG_URL */], function (state, o) {
    if (o.bShowDialog) {
        if (o.type != "custom") {
            state.settingType.pageSize = o.pageSize;
            state.settingType.currentPage = o.currentPage;
        }
        state.settingType.type = o.type;
        state.settingType.bShowDialog = o.bShowDialog;
        state.settingType.modulesIndex = o.modulesIndex;
        state.settingType.listIndex = o.listIndex;
        state.settingType.dialogTitle = o.dialogTitle;
    } else {
        state.settingType.bShowDialog = o.bShowDialog;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_type__["p" /* SET_MODULES_URL */], function (state, _ref) {
    var rootState = _ref.rootState,
        o = _ref.o;

    var nListIndex = state.settingType.listIndex;
    var nModulesIndex = state.settingType.modulesIndex;
    var list = rootState.modules[nModulesIndex].data.list[nListIndex];
    list.urlCatetory = o.dialogTitle;
    list.urlName = o.urlName;
    list.url = o.url;
}), _mutations);

var actions = {
    onOffDialogUrl: function onOffDialogUrl(_ref2, o) {
        var commit = _ref2.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_type__["o" /* ON_OFF_DIALOG_URL */], o);
    },
    setDialogUrl: function setDialogUrl(_ref3, o) {
        var commit = _ref3.commit;

        __WEBPACK_IMPORTED_MODULE_2_config__["d" /* apiDialogUrl */].getDialog(o, {
            setDialogUrl: function setDialogUrl(data) {
                commit(__WEBPACK_IMPORTED_MODULE_1__mutation_type__["n" /* SET_DIALOG_URL */], { data: data });
            },
            onOffDialogUrl: function onOffDialogUrl() {
                commit(__WEBPACK_IMPORTED_MODULE_1__mutation_type__["o" /* ON_OFF_DIALOG_URL */], o);
            }
        });
    },
    setModulesUrl: function setModulesUrl(_ref4, o) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_type__["p" /* SET_MODULES_URL */], { rootState: rootState, o: o });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__ = __webpack_require__(3);


var _SET_MODULE_INFO$SET_;



/* harmony default export */ __webpack_exports__["a"] = (_SET_MODULE_INFO$SET_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["G" /* SET_MODULE_INFO */], function (state, o) {
    if (o.moduleData == "" || !o.moduleData) {
        o.moduleData = "[]";
    }
    sessionStorage.setItem("modules", o.moduleData);
    state.modules = JSON.parse(o.moduleData);
    state.pageSetting.modulesId = o.id;
    state.pageSetting.type = o.type;
    state.pageSetting.default = o.default;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["H" /* SET_PAGE_LIST */], function (state, o) {
    state.pageList = o.pageList;
    state.customPageList = o.pageList.filter(function (item) {
        return item.default == 0;
    });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["I" /* UPDATE_PAGE */], function (state, o) {
    var pageListLen = state.pageList.length;
    for (var i = 0; i < pageListLen; i++) {
        if (state.pageList[i].id == o.id) {
            state.pageList[i].title = o.title;
            state.pageList[i].thumb_pic = o.thumb_pic;
            break;
        }
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["J" /* ADD_PAGE */], function (state, o) {
    state.customPageList.unshift(o);
    state.pageList.unshift(o);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["K" /* REMOVE_PAGE */], function (state, o) {
    var pageListLen = state.customPageList.length;
    for (var i = 0; i < pageListLen; i++) {
        if (state.customPageList[i].id == o.id) {
            state.customPageList.splice(i, 1);
            break;
        }
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["L" /* SEARCH_PAGE_LIST */], function (state, o) {
    var aFilterPageList = state.pageList.filter(function (item) {
        return item.title == "" ? item.default == o.default : item.default == o.default && item.title.toLowerCase().includes(o.title.toLowerCase());
    });
    if (o.default == 0) {
        state.customPageList = aFilterPageList;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["M" /* REMOVE_MENU_URL */], function (state, o) {
    var list = state.modules[o.modulesIndex].data.list[o.listIndex];
    list.url = "";
    list.urlCatetory = "";
    list.urlName = "";
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MODULE_INFO$SET_, __WEBPACK_IMPORTED_MODULE_1__mutation_type_js__["N" /* UPDATE_PAGE_PIC */], function (state, o) {
    var pageLength = state.pageList.length;
    for (var i = 0; i < pageLength; i++) {
        if (state.pageList[i].id == o.id) {
            state.pageList[i].pic = o.pic;
            break;
        }
    }
}), _SET_MODULE_INFO$SET_);

/***/ })

},[193]);


// WEBPACK FOOTER //
// public/js/app.js